import React, { useMemo } from 'react';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { getNews } from '../shared/news/news';
import '../App.css';

const HOME_LINKS = [
    { to: '/news', src: '/news_banner.png', label: 'News' },
    { to: '/tierlist', src: '/tierlist_banner.png', label: 'Tierlist' },
    { to: '/units', src: '/units_banner.png', label: 'Units' },
    { to: '/guides', src: '/guides_banner.png', label: 'Guides' },
    { to: '/equips', src: '/equips_banner.png', label: 'Equips' },
];

function truncateIntro(text, maxLength = 160) {
    const normalized = String(text || '').replace(/\s+/g, ' ').trim();
    if (normalized.length <= maxLength) {
        return normalized;
    }
    return `${normalized.slice(0, maxLength).replace(/\s+\S*$/, '')}…`;
}

function Main() {
    const latestNews = useMemo(() => {
        const articles = getNews();
        if (!articles.length) {
            return null;
        }
        return [...articles].sort((a, b) => b.id - a.id)[0];
    }, []);

    return (
        <Container className="gs-page">
            <div className="gs-page-gutter gs-home">
                <header className="gs-home__hero">
                    <img
                        className="gs-home__brand"
                        src="/Banner.png"
                        alt=""
                        decoding="async"
                    />
                    <h1 className="gs-home__title">Grand Summoners Database</h1>
                    <p className="gs-home__lede">
                        Welcome! Browse Units, Equips, Tierlists, Guides for Grand Summoners.
                    </p>
                </header>

                <nav className="gs-home-grid" aria-label="Site sections">
                    {HOME_LINKS.map(({ to, src, label }) => (
                        <Link key={to} to={to} className="gs-banner-link">
                            <img src={src} alt={label} loading="lazy" decoding="async" />
                        </Link>
                    ))}
                </nav>

                {latestNews && (
                    <aside className="gs-home-teaser" aria-labelledby="home-latest-changelog">
                        <div className="gs-home-teaser__copy">
                            <p className="gs-home-teaser__eyebrow">Latest changelog</p>
                            <h2 id="home-latest-changelog" className="gs-home-teaser__title">
                                {latestNews.date}
                            </h2>
                            <p className="gs-home-teaser__intro">
                                {truncateIntro(latestNews.article?.intro)}
                            </p>
                        </div>
                        <Link to="/news" className="gs-btn gs-btn--ghost">
                            Read changelog
                        </Link>
                    </aside>
                )}
            </div>
        </Container>
    );
}

export default Main;
